import type { MouseEvent } from "react";

// Client-side routing on the History API; the server answers every path with index.html (ADR-0001).
export function go(path: string, replace = false, state: unknown = null) {
  window.history[replace ? "replaceState" : "pushState"](state, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

/** Sets (null removes) one query parameter of the current address with `replace`, so Back does not step through panel states. */
export function replaceQuery(key: string, value: string | number | null) {
  const u = new URL(window.location.href);
  if (value === null) u.searchParams.delete(key); else u.searchParams.set(key, String(value));
  window.history.replaceState(null, "", u.pathname + u.search);
}

/** Link onClick: plain left click navigates without reload; modified clicks keep the browser default (new tab). */
export function navigate(e: MouseEvent<HTMLAnchorElement>, path: string) {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  e.preventDefault();
  go(path);
}

export const SOURCES = "/sources";
export const uploadHref = (id: number) => `${SOURCES}/uploads/${id}`;
